import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpHeaders, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SignupComponent } from './signup.component';
import { SignupRoutingModule } from './signup-routing';
import { SharedModule } from '../../shared/shared.module';

// import { PasswordStrengthBarModule } from 'ng2-password-strength-bar';
import { FooterComponent } from "../../footer/footer.component";


@NgModule({ declarations: [
        SignupComponent
    ], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SignupRoutingModule,
        SharedModule,
        FooterComponent], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class SignupModule { }
